import { useToggleState } from '@lingoda/hooks';
import { Link } from '../Link';

interface Props {
    label: string;
    reveal?: boolean;
}

const ClickToReveal = ({ children, label, reveal }: React.PropsWithChildren<Props>) => {
    const [showField, toggleView] = useToggleState(false);

    return showField || reveal ? (
        <>{children}</>
    ) : (
        <Link component="button" variant="h4" onClick={toggleView}>
            {label}
        </Link>
    );
};

export default ClickToReveal;
